export default __webpack_public_path__ + "static/media/card4.e279ace3.png";